(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dt-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const escapeHtml = (value) => {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const initCarousel = (stage) => {
    if (!stage || stage.dataset.dtCarouselReady === '1') return;

    stage.dataset.dtCarouselReady = '1';

    const viewport = stage.querySelector('[data-dt-review-viewport]');
    const prev = stage.querySelector('[data-dt-review-prev]');
    const next = stage.querySelector('[data-dt-review-next]');

    if (!viewport) return;

    const move = (direction) => {
      const card = viewport.querySelector('.dt-reviews__card');
      if (!card) return;

      const track = viewport.querySelector('.dt-reviews__track');
      const styles = track ? getComputedStyle(track) : null;
      const gap = styles ? parseFloat(styles.columnGap || styles.gap || 0) : 0;

      viewport.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: 'smooth'
      });
    };

    if (prev) prev.addEventListener('click', () => move(-1));
    if (next) next.addEventListener('click', () => move(1));
  };

  const normalizePayload = (payload) => {
    const root = payload && payload.result ? payload.result : payload || {};
    const reviews = Array.isArray(root.reviews) ? root.reviews : [];

    return {
      rating: root.rating ?? root.average_rating ?? root.averageRating ?? '',
      count: root.user_ratings_total ?? root.review_count ?? root.total_reviews ?? root.totalReviews ?? '',
      reviews
    };
  };

  const renderGoogleReview = (review, profileUrl) => {
    const name = review.author_name || review.authorName || review.name || 'Google reviewer';
    const rating = Math.max(0, Math.min(5, Number(review.rating || 0)));
    const text = review.text || review.original_text || review.review_text || '';
    const time = review.relative_time_description || review.relativeTimeDescription || review.time_text || review.date || '';
    const avatar = review.profile_photo_url || review.profilePhotoUrl || review.avatar || '';
    const reviewUrl = review.review_url || review.reviewUrl || review.author_url || profileUrl || '';

    const initials = name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('');

    const stars = Array.from({ length: 5 }, (_, index) => {
      return `<span class="dt-reviews__star ${index < Math.round(rating) ? 'is-filled' : ''}" aria-hidden="true">★</span>`;
    }).join('');

    const avatarHtml = avatar
      ? `<img src="${escapeHtml(avatar)}" alt="${escapeHtml(name)}" class="dt-reviews__avatar-image" loading="lazy">`
      : `<span class="dt-reviews__initials">${escapeHtml(initials || 'G')}</span>`;

    const linkHtml = reviewUrl
      ? `<a href="${escapeHtml(reviewUrl)}" class="dt-reviews__source-link" target="_blank" rel="noopener noreferrer">View on Google</a>`
      : '';

    return `
      <article class="dt-reviews__card">
        <div class="dt-reviews__reviewer">
          <div class="dt-reviews__avatar">${avatarHtml}</div>
          <div class="dt-reviews__reviewer-info">
            <h3 class="dt-reviews__name">${escapeHtml(name)}</h3>
            <div class="dt-reviews__meta-row">
              <span class="dt-reviews__source-logo" aria-hidden="true">G</span>
              <span>Google review</span>
              ${time ? `<span>•</span><span>${escapeHtml(time)}</span>` : ''}
            </div>
          </div>
        </div>

        <div class="dt-reviews__stars" role="img" aria-label="${rating} out of 5 stars">
          ${stars}
        </div>

        <div class="dt-reviews__verified">
          <span class="dt-reviews__verified-icon">✓</span>
          Review from Google
        </div>

        ${text ? `<div class="dt-reviews__text">${escapeHtml(text)}</div>` : ''}
        ${linkHtml}
      </article>
    `;
  };

  const initSection = async (section) => {
    if (!section || section.dataset.dtReviewReady === '1') return;
    section.dataset.dtReviewReady = '1';

    section.querySelectorAll('[data-dt-review-stage]:not([hidden])').forEach(initCarousel);

    if (section.dataset.dtSourceMode !== 'google_live') return;

    const endpoint = (section.dataset.dtGoogleEndpoint || '').trim();
    const profileUrl = (section.dataset.dtGoogleProfile || '').trim();
    const limit = Math.max(1, Number(section.dataset.dtGoogleLimit || 6));
    const useFallback = section.dataset.dtGoogleFallback === 'true';

    const status = section.querySelector('[data-dt-google-status]');
    const summary = section.querySelector('[data-dt-google-summary]');
    const stage = section.querySelector('[data-dt-google-stage]');
    const track = section.querySelector('[data-dt-google-track]');
    const manual = section.querySelector('[data-dt-manual-stage]');

    const showFallback = (message) => {
      if (status) {
        status.textContent = message || 'Google reviews could not be loaded.';
        status.classList.add('is-error');
      }

      if (useFallback && manual) {
        manual.hidden = false;
        initCarousel(manual);
      }
    };

    if (!endpoint) {
      showFallback('Add your secure Google Reviews endpoint in the section settings to enable live reviews.');
      return;
    }

    try {
      const url = new URL(endpoint, window.location.origin);
      if (profileUrl) url.searchParams.set('profile_url', profileUrl);
      url.searchParams.set('limit', String(limit));

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'omit'
      });

      if (!response.ok) throw new Error(`Google reviews endpoint returned ${response.status}`);

      const payload = normalizePayload(await response.json());
      const reviews = payload.reviews.slice(0, limit);

      if (!reviews.length) throw new Error('No Google reviews were returned');

      if (track) {
        track.innerHTML = reviews.map((review) => renderGoogleReview(review, profileUrl)).join('');
      }

      const ratingNode = section.querySelector('[data-dt-google-rating]');
      const countNode = section.querySelector('[data-dt-google-count]');

      if (ratingNode && payload.rating !== '') ratingNode.textContent = Number(payload.rating).toFixed(1);

      if (countNode && payload.count !== '') {
        const count = Number(payload.count);
        countNode.textContent = Number.isFinite(count)
          ? `${count.toLocaleString()} reviews`
          : `${payload.count} reviews`;
      }

      if (summary) summary.hidden = false;
      if (stage) {
        stage.hidden = false;
        initCarousel(stage);
      }

      if (manual) manual.hidden = true;
      if (status) status.hidden = true;
    } catch (error) {
      console.warn('[DT Customer Reviews] Live Google reviews failed:', error);
      showFallback('Live Google reviews are temporarily unavailable.');
    }
  };

  document.querySelectorAll('[data-dt-section="customer-reviews"]').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-dt-section="customer-reviews"]')
      || (event.target.matches?.('[data-dt-section="customer-reviews"]') ? event.target : null);

    if (section) {
      section.dataset.dtReviewReady = '0';
      initSection(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-shop-by-categories"] && !Shopify.designMode) return;
  try {
    

(() => {

  const sections = document.querySelectorAll('[data-dt-section="shop-by-categories"]');

  sections.forEach((section) => {

    if (section.dataset.dtCatsInit === '1') return;

    section.dataset.dtCatsInit = '1';

    const viewport = section.querySelector('[data-dt-cats-viewport]');
    const prev = section.querySelector('[data-dt-cats-prev]');
    const next = section.querySelector('[data-dt-cats-next]');

    if (!viewport) return;


    const scrollAmount = () => {
      return Math.max(
        viewport.clientWidth * 0.72,
        240
      );
    };


    if (prev) {

      prev.addEventListener('click', () => {

        viewport.scrollBy({
          left: -scrollAmount(),
          behavior: 'smooth'
        });

      });

    }


    if (next) {

      next.addEventListener('click', () => {

        viewport.scrollBy({
          left: scrollAmount(),
          behavior: 'smooth'
        });

      });

    }

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-social-media-gallery"] && !Shopify.designMode) return;
  try {
    

(() => {

  const sections =
    document.querySelectorAll('[data-dt-social-section]');


  /* =========================================================
     ESCAPE
     ========================================================= */

  const escapeHTML = (value = '') => {

    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  };


  /* =========================================================
     NORMALIZE PLATFORM
     ========================================================= */

  const platformName = (value = '') => {

    const platform =
      String(value).toLowerCase();

    if (platform.includes('instagram')) return 'instagram';

    if (platform.includes('facebook')) return 'facebook';

    if (platform.includes('tiktok')) return 'tiktok';

    return 'other';

  };


  /* =========================================================
     ICON
     ========================================================= */

  const platformIcon = (platform) => {

    if (platform === 'facebook') return 'f';

    if (platform === 'instagram') return '◎';

    if (platform === 'tiktok') return '♪';

    return '•';

  };


  sections.forEach(async (section) => {

    if (section.dataset.dtSocialReady === '1') return;

    section.dataset.dtSocialReady = '1';


    const filters =
      section.querySelectorAll(
        '[data-dt-social-filter]'
      );


    const localWrap =
      section.querySelector(
        '[data-dt-social-local]'
      );


    const connectedWrap =
      section.querySelector(
        '[data-dt-social-connected]'
      );


    const connectedGrid =
      section.querySelector(
        '[data-dt-social-connected-grid]'
      );


    const status =
      section.querySelector(
        '[data-dt-social-status]'
      );


    const mode =
      section.dataset.dtFeedMode || 'local';


    const endpoint =
      section.dataset.dtFeedUrl || '';


    const limit =
      Number(
        section.dataset.dtFeedLimit || 12
      );


    /* =======================================================
       FILTERING
       ======================================================= */

    const bindFilters = () => {

      filters.forEach((button) => {

        button.addEventListener(
          'click',
          () => {

            filters.forEach((other) => {
              other.classList.remove('is-active');
            });

            button.classList.add('is-active');


            const selected =
              button.dataset.dtSocialFilter;


            section
              .querySelectorAll(
                '[data-dt-social-card]'
              )
              .forEach((card) => {

                const platform =
                  card.dataset.platform;


                const show =
                  selected === 'all'
                  ||
                  platform === selected;


                card.hidden = !show;

              });

          }
        );

      });

    };


    bindFilters();


    /* =======================================================
       LOCAL MODE
       ======================================================= */

    if (
      mode !== 'connected'
      ||
      !endpoint
    ) {

      return;

    }


    /* =======================================================
       CONNECTED MODE

       EXPECTED NORMALIZED JSON:

       {
         "posts": [
           {
             "platform": "instagram",
             "media_type": "image",
             "media_url": "...",
             "thumbnail_url": "...",
             "permalink": "...",
             "handle": "@englishcares"
           }
         ]
       }
       ======================================================= */

    try {

      if (status) {

        status.hidden = false;

        status.textContent =
          'Loading connected social posts…';

      }


      const url =
        new URL(
          endpoint,
          window.location.origin
        );


      url.searchParams.set(
        'limit',
        String(limit)
      );


      const response =
        await fetch(
          url.toString(),
          {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          `Feed returned ${response.status}`
        );

      }


      const payload =
        await response.json();


      const posts =
        Array.isArray(payload)
        ? payload
        : (
            Array.isArray(payload.posts)
            ? payload.posts
            : []
          );


      if (!posts.length) {

        throw new Error(
          'Connected feed returned no posts'
        );

      }


      connectedGrid.innerHTML =
        posts
          .slice(0, limit)
          .map((post) => {

            const platform =
              platformName(post.platform);


            const mediaType =
              String(
                post.media_type || 'image'
              ).toLowerCase();


            const mediaUrl =
              post.media_url || '';


            const thumbnail =
              post.thumbnail_url || mediaUrl;


            const permalink =
              post.permalink || '#';


            const handle =
              post.handle
              ||
              post.username
              ||
              '';


            let mediaMarkup = '';


            if (
              mediaType === 'video'
              &&
              mediaUrl
            ) {

              mediaMarkup = `
                <video
                  class="dt-social__video"
                  src="${escapeHTML(mediaUrl)}"
                  poster="${escapeHTML(thumbnail)}"
                  muted
                  playsinline
                  preload="metadata"
                  controls
                ></video>
              `;

            } else {

              mediaMarkup = `
                <img
                  class="dt-social__image"
                  src="${escapeHTML(thumbnail)}"
                  loading="lazy"
                  alt="${escapeHTML(handle || (platform + ' social post'))}"
                >
              `;

            }


            return `
              <article
                class="dt-social__card"
                data-dt-social-card
                data-platform="${platform}"
              >

                <a
                  href="${escapeHTML(permalink)}"
                  class="dt-social__card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >

                  <div class="dt-social__media">
                    ${mediaMarkup}
                  </div>

                  <footer class="dt-social__card-footer">

                    <span class="dt-social__handle">
                      ${escapeHTML(handle)}
                    </span>

                    <span
                      class="
                        dt-social__platform
                        dt-social__platform--${platform}
                      "
                    >
                      ${platformIcon(platform)}
                    </span>

                  </footer>

                </a>

              </article>
            `;

          })
          .join('');


      connectedWrap.hidden = false;

      localWrap.hidden = true;


      if (status) {

        status.hidden = true;

      }

    } catch (error) {

      /*
        IMPORTANT:
        Connected feed failure deliberately falls back
        to local Shopify blocks.
      */

      connectedWrap.hidden = true;

      localWrap.hidden = false;


      if (status) {

        status.hidden = false;

        status.textContent =
          'Connected feed unavailable — showing local gallery.';

      }


      console.warn(
        'DT Social Gallery:',
        error
      );

    }

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
